// import {useRequestHeaders}

export default {
  async nuxtServerInit({ dispatch }) {
    await this.$auth.initialLogin();
    await this.$auth.setAxiosHeader(this.$cookies.get('auth'));

    try {
      await Promise.all([
        dispatch('layout/fetchUserMenuData'),
        dispatch('layout/fetchCategoryMenuData'),
        dispatch('layout/fetchAutocompleteCategoryMenuData'),
        dispatch('settings/fetchBusinessVariables'),
        this.$auth.isLogged() ? dispatch('costCenters/fetchCostCenters') : '',
      ]);
    } catch (e) {}
  },
};
